import React, { Component } from 'react';

import './personalizar.css'

import LogoEmpresa from '../../../img/logoEmpresaEjemplo.png';
import IconoCambiar from '../../../img/logoAgregarImagen.svg';
import IconDeleteName from '../../../img/iconDeleteName.png';

import Funciones from '../../../functions/Parametrizacion/handleNombre';

class Parametrizacion extends Component {

    constructor(){
        super();
        this.state = {
            botonGuardar: false,
            errorInput: false,
            nombresSugeridos: []
        }

        this.cargarDatos();
    }

    cargarDatos = async() => {
        let nombreChatbot = await Funciones.GetNombreActual();
        if(nombreChatbot){
            this.nombreChat.value = nombreChatbot;
        }
    }

    cambiarNombre = (e) => {
        let nuevoNombre = this.nombreChat.value;
        
        if(nuevoNombre){
            Funciones.ValidarNombreUnico(nuevoNombre).then(res => {
                this.setState({errorInput: res});
                if(!res){
                    this.setState({
                        nombresSugeridos: Funciones.GenerarNombres(nuevoNombre)
                    });
                    this.setState({botonGuardar: true})
                }else{
                    this.setState({botonGuardar: false});
                }
            });
        }
    }

    guardarCambios = () => {
        let nuevoNombre = this.nombreChat.value;
        
        if(nuevoNombre){
            if(isNaN(nuevoNombre)){
                if(nuevoNombre.length > 3){
                    Funciones.PostNombreBot(nuevoNombre);
                }else{
                    alert("El nombre debe tener como minimo 3 caracteres");
                }
            }else{
                this.nombreChat.value = '';
                alert("No se permiten numeros");
            }
        }else{
            alert("No ha ingresado ningun nombre");
        }
    }

    elegirOpcion = (e) => {
        let elemento = e.target.value;
        if(elemento){
            if(isNaN(elemento)){
                this.nombreChat.value = elemento
                Funciones.PostNombreBot(elemento);
            }else{
                this.nombreChat.value = '';
                alert("No se permiten numeros");
            }
        }else{
            alert("No ha ingresado ningun nombre");
        }
    }

    negarOpcion = (i) => {
        this.state.nombresSugeridos.splice(i, 1)
        this.setState({
            nombresSugeridos: this.state.nombresSugeridos
        })
    }
    
    render(){
        return(
            <div className='col s12 m4 x5'>
                <div className='contenedorPersonalizar'>
                    <div className='headPersonalizar'>
                        <p>Personalización</p>
                    </div>
                    <div className='detallesEmpresa'> 
                        <div className='logoEmpresa'>
                            <img src={LogoEmpresa} alt='logoEmpresa'/>
                            <img id='btnCambiarImagen' src={IconoCambiar} alt='logoCambiar'/>
                        </div>
                        <div className='nombreChatbot'>
                            <p>Nombre</p>
                            <input type='text' placeholder='Nombre del Chatbot' ref={element => this.nombreChat = element} onKeyUpCapture={this.cambiarNombre}/>
                            {this.state.errorInput && <p className='errorInput'>Este nombre ya está en uso</p>}
                        </div>
                        <div className='sugerenciaNombre'>
                            <p>Sugerencias de nombres</p>
                            {
                                this.state.nombresSugeridos.map((item, i) => {
                                    if(i <= 2){
                                        return (
                                            <div className='containSugerencia' key={i}>
                                                <input key={i} className='nameSugerido' type='text' maxLength='20' value={item} onClick={this.elegirOpcion} readOnly />
                                                <img className='deleteName' src={IconDeleteName} alt='borrarNombre' onClick={()=>this.negarOpcion(i)}/>
                                            </div>)
                                    }else{
                                        return null
                                    }
                                })
                            }
                        </div>
                        { (this.state.botonGuardar)? <div className='btnGuardarParametros' onClick={this.guardarCambios}><p>Guardar</p></div> : '' }
                    </div>
                </div>
            </div>
        );
    }
}

export default Parametrizacion;